import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useDemocracyWs from '../../../../../../views/democracy/useDemocracyWs';
import { WsTopic, WsEventType } from '../../../../../../views/democracy/constants';
import { secondsToHHMMSS } from '../../../../../../views/democracy/utils';

// Карточка команды (горизонтальный ряд): цвет/имя, номер/рейтинг/баланс, live-время, санкции.
export default function TeamCard({ team, currentTeamOrderId, democracyId, onSelect, onEdit }) {
    const teamId = team.teamId || team.id;
    const [time, setTime] = useState(team.remainingSeconds ?? 0);
    const sanctions = team.activeSanctions || [];

    useEffect(() => { setTime(team.remainingSeconds ?? 0); }, [team.remainingSeconds]);

    useDemocracyWs(
        teamId ? WsTopic.team(democracyId, teamId) : null,
        WsEventType.TIME,
        (payload) => { if (payload && typeof payload.remainingSeconds === 'number') setTime(payload.remainingSeconds); }
    );

    return (
        <div className={`tcard${team.orderId === currentTeamOrderId ? ' active' : ''}`} onClick={onSelect}>
            <div className="thead" style={{ background: team.color }}>{team.name}</div>
            <div className="tbody">
                <div className="tnum">Номер {team.orderId}</div>
                <div className="tmeta">Рейтинг {team.rating} · Баланс {team.balance}</div>
                <div className="ttime">{secondsToHHMMSS(time)}</div>
                <button type="button" className="cbtn cbtn-blue" onClick={(e) => { e.stopPropagation(); onEdit(team); }}>
                    Редактировать
                </button>
                {sanctions.length > 0 && (
                    <div className="tapplied">
                        {sanctions.map((s, i) => (
                            <span className="ap" key={s.sanctionId || s.id || i}>
                                {s.title}
                                {s.durationLeft != null && (
                                    <i className="ap-dur" title="Осталось кругов">{s.durationLeft}</i>
                                )}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

TeamCard.propTypes = {
    team: PropTypes.object.isRequired,
    currentTeamOrderId: PropTypes.number,
    democracyId: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired
};

TeamCard.defaultProps = { currentTeamOrderId: null };
